import {Component, DoCheck} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';

import {NlrMaxDateValidatorDirective} from '../../common/directive/nlr-max-date.directive';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';

@Component({
    selector: 'land-registry-advice',
    imports: [FormsModule, NlrMaxDateValidatorDirective, NlrFormFieldHasErrorPipe],
    templateUrl: './land-registry-advice.component.html',
    styleUrl: './land-registry-advice.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class LandRegistryAdviceComponent implements DoCheck {
    title = 'Land registry advice';

    permissions = ['EDIT_LODGE', 'VIEW_LODGE'];

    // ISO date string (yyyy-MM-dd)
    maxDateIsoString: string = this.toIsoString(new Date());

    // ISO date string (yyyy-MM-dd) bound to the input[type="date"] field
    adviceDateIsoString: string;

    // ISO date string (yyyy-MM-dd) to track PlanModel#adviceDate changes
    private planModelAdviceDateIsoStringAtLastCheck: string;

    constructor(
        private readonly planModelService: PlanModelService,
        private readonly permissionsService: PermissionsService
    ) {}

    ngDoCheck() {
        // The PlanModel#adviceDate value can be either an ISO date string (yyyy-MM-dd) upon input, or a number (timestamp) after save / reload.
        // If the PlanModel#adviceDate is equivalent to a different yyyy-MM-dd value since the last check, update this.adviceDate.
        const planModelAdviceDateIsoString = this.planModelAdviceDateToIsoString();
        if (this.planModelAdviceDateIsoStringAtLastCheck !== planModelAdviceDateIsoString) {
            this.adviceDateIsoString = planModelAdviceDateIsoString;
            this.planModelAdviceDateIsoStringAtLastCheck = planModelAdviceDateIsoString;
        }
    }

    onChangeAdviceDate() {
        // Only update PlanModel#adviceDate if it is equivalent to a different yyyy-MM-dd value than this.adviceDate.
        if (this.planModelAdviceDateToIsoString() !== this.adviceDateIsoString) {
            this.getModel().adviceDate = this.adviceDateIsoString;
        }
    }

    showComponent() {
        return this.permissionsService.hasPermission(this.permissions);
    }

    getModel() {
        return this.planModelService.getModel();
    }

    isDisabled() {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.permissions);
    }

    preventKeydownEvent(event: KeyboardEvent) {
        event.preventDefault();
    }

    adviceDateDisplayString() {
        if (this.adviceDateIsoString) {
            const parts = this.adviceDateIsoString.split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
        }
        return '';
    }

    private toIsoString(date: Date) {
        return date.toISOString().slice(0, 10);
    }

    private planModelAdviceDateToIsoString() {
        const adviceDate = this.getModel().adviceDate;
        return adviceDate ? this.toIsoString(new Date(adviceDate)) : undefined;
    }
}
